import useModal from "../../useModal";
import UseContext from "../../../../hooks/useContext";
import Modalheader from "../../components/header";
import ModalBody from "../../components/body";
import ModalFooter from "../../components/footer";
import Button from "../../../../components/button";
import SubmitButton from "../../../../components/button/SubmitButton";
import StyledInput from "../../../../components/styledInput/StyledInput";
import { TrashIcon } from "../../../../assets/icons";
import React, { useState, useEffect, useMemo } from "react";
import ApiDatabase from "../../../../server";

const ModalEditSector = () => {
  const { toggle } = useModal();
  const { modalData } = UseContext();
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const sector = modalData?.sector;
  const onSuccess = modalData?.onSuccess;
  const onDeleteRequest = modalData?.onDeleteRequest;

  useEffect(() => {
    if (sector?.name) {
      setName(sector.name);
    }
  }, [sector]);

  const canSubmit = useMemo(() => name.trim().length > 0, [name]);

  const handleSubmit = () => {
    if (!name.trim() || !sector?._id) return;
    setSubmitting(true);
    ApiDatabase.putUpdateSector(
      { id: sector._id, name: name.trim() },
      () => {
        setSubmitting(false);
        if (onSuccess) onSuccess();
        toggle();
      },
      () => setSubmitting(false)
    );
  };

  const handleDeleteClick = () => {
    if (onDeleteRequest) {
      onDeleteRequest(sector);
    }
    toggle();
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Modifier un secteur
      </Modalheader>
      <ModalBody>
        <StyledInput
          type="text"
          label="Nom du secteur"
          placeholder="Nom du secteur"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <div className="flex w-full items-center justify-between">
          <Button
            color="SECONDARY"
            size="LG"
            onClick={handleDeleteClick}
          >
            <div className="flex items-center gap-1">
              <TrashIcon wh={20} color="#374151" />
              Supprimer
            </div>
          </Button>
          <div className="flex gap-2">
            <Button color="SECONDARY" size="LG" onClick={toggle}>
              Annuler
            </Button>
            <SubmitButton
              loading={submitting}
              onClick={handleSubmit}
              disabled={!canSubmit}
            />
          </div>
        </div>
      </ModalFooter>
    </>
  );
};

export default ModalEditSector;
